import MentionsLegales from './MentionsLegales';

export default MentionsLegales;